import {
  ParentSignUpModel,
  OrganizationSignUpModel,
  ParentOrganizationLoginModel,
  StudentLoginModel
} from '@shared/models/LoginModels';
import router from '@web/router';
import RouterHelper from '@shared/helpers/router.helper';
import { ResetPasswordModel } from '@web/models/LoginModels/ResetPasswordModel';
import { WebAuthResponseModel } from '@shared/models/AuthResponseModel/WebAuthResponseModel';
import ApiService from './ApiService';

const routerHelper = new RouterHelper();

export default class AccountService extends ApiService {
  constructor() {
    super('/account');
  }

  accountParentRegistration(params: ParentSignUpModel): Promise<void> {
    return this.post('/parent/registration', params).then(() => {
      router.push({
        name: routerHelper
          .signup()
          .greeting()
          .getName(),
        params: {
          email: params.email
        }
      });
    });
  }

  accountOrganizationRegistration(params: OrganizationSignUpModel): Promise<void> {
    return this.post('/organization/registration', params).then(() => {
      router.push({
        name: routerHelper
          .signup()
          .greeting()
          .getName(),
        params: {
          email: params.email
        }
      });
    });
  }

  accountOrganizationAndParentLogin(params: ParentOrganizationLoginModel) {
    return this.post('/login', params)
      .then((res) => res.data as WebAuthResponseModel)
      .then(({ authKey, redirectURL }: WebAuthResponseModel) => {
        const href = `${window.location.origin}/login`;
        window.location.href = `${redirectURL}/login/${authKey}?returnUrl=${encodeURIComponent(
          href
        )}`;
      });
  }

  getUserRole(params: { userName: any }): Promise<void> {
    return this.get('/study/login/role/get', { params });
  }

  checkEmail(params: { email: string }): Promise<void> {
    return this.post('/registration/check/email', params);
  }

  accountStudyLogin(params: StudentLoginModel/* , isSafari = false */) {
    return this.post('/study/login', params)
      .then((res) => res.data as WebAuthResponseModel)
      .then(({ authKey, redirectURL }: WebAuthResponseModel) => {
        // if (isSafari) {
        //   throw new Error('Is safari');
        // }
        window.location.href = `${redirectURL}/login/${authKey}?returnUrl=${encodeURIComponent(
          window.location.href
        )}`;
        return Promise.resolve();
      });
  }

  accountForgotPassword(params: { email: string }) {
    return this.get('/forgotPassword', { params });
  }

  accountResetPassword(params: ResetPasswordModel) {
    return this.post('/resetPassword', params);
  }

  accountVerifyResetPasswordToken(params: any) {
    return this.get('/verify/resetPasswordToken', { params });
  }

  accountVerifyEmail(params: any) {
    return this.post('/verify/email', params);
  }

  accountSendEmailToken(params: { [email: string]: string }) {
    return this.get('/sendEmailToken', { params });
  }

  resendEmailToken(email: string) {
    return this.get(`/resendEmailToken?email=${email}`);
  }
}
